// import $j from 'jquery';

export const audioSineWave = (audioHelper, visualizeElem) => {
  const analyser = audioHelper.audio_context.createAnalyser();
  audioHelper.input.connect(analyser);

  analyser.minDecibels = -90;
  analyser.maxDecibels = -10;
  analyser.smoothingTimeConstant = 0.85;

  analyser.fftSize = 2048;
  const bufferLength = analyser.fftSize;
  // console.log(bufferLength);
  const dataArray = new Uint8Array(bufferLength);

  const canvas = visualizeElem[0];
  const canvasCtx = canvas.getContext('2d');

  // canvas.setAttribute('width', 400);

  const WIDTH = canvas.width;
  const HEIGHT = canvas.height;
  // console.log(WIDTH, HEIGHT);
  canvasCtx.clearRect(0, 0, WIDTH, HEIGHT);

  let drawVisual;

  function draw() {
    // console.log(1);
    drawVisual = requestAnimationFrame(draw);

    analyser.getByteTimeDomainData(dataArray);

    canvasCtx.fillStyle = '#fff';
    canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

    canvasCtx.lineWidth = 2;
    canvasCtx.strokeStyle = '#0abff1';

    canvasCtx.beginPath();

    const sliceWidth = (WIDTH * 1.0) / bufferLength;
    let x = 0;

    for (let i = 0; i < bufferLength; i++) {
      const v = dataArray[i] / 128.0;
      const y = (v * HEIGHT) / 2;

      if (i === 0) {
        canvasCtx.moveTo(x, y);
      } else {
        canvasCtx.lineTo(x, y);
      }

      x += sliceWidth;
    }

    canvasCtx.lineTo(canvas.width, canvas.height / 2);
    canvasCtx.stroke();
  }

  draw();

  function cancelDraw() {
    cancelAnimationFrame(drawVisual);
  }

  return { draw, cancelDraw };
};
